import { TFunction } from 'i18next'

import { DataForSearchTour } from 'entities/tour/models/search-tour'

const MAX_RESORTS_TO_SHOW = 1
const MIN_RESORTS_FOR_PLURAL = 2
const MAX_RESORTS_FOR_GENITIVE = 4

export const getHeaderTitle = (
  data: DataForSearchTour | undefined,
  t: TFunction<'translation', undefined>,
): string => {
  const countryName = data?.country?.name || ''
  const resorts = data?.resorts || []

  if (resorts.length === 0) {
    return countryName
  }

  if (resorts.length > MAX_RESORTS_TO_SHOW) {
    const resortWord = getResortWord(resorts.length, t)
    return `${countryName}, ${resorts.length} ${resortWord}`
  }

  const resortNames = resorts.map((r) => r.name).join(', ')
  return `${countryName}, ${resortNames}`
}

const getResortWord = (
  count: number,
  t: TFunction<'translation', undefined>,
) => {
  if (count >= MIN_RESORTS_FOR_PLURAL && count <= MAX_RESORTS_FOR_GENITIVE)
    return t('tours_block.resort_genitive')
  return t('tours_block.resorts')
}
